<template>
<div>
    <div class="grid grid-cols-3 pt-6 pb-6 gap-6">
        <statistics-card-line class="rounded-4xl" v-if="revenueGenerated.analyticsData" icon="UserIcon" :statistic="revenueGenerated.analyticsData.revenue" statisticTitle="Usuarios" :chartData="revenueGenerated.series" color="success" type="area" />
        <statistics-card-line class="rounded-4xl" v-if="revenueGenerated.analyticsData" icon="PlayIcon" :statistic="revenueGenerated.analyticsData.revenue" statisticTitle="Usuarios" :chartData="revenueGenerated.series" color="success" type="area" />
        <statistics-card-line class="rounded-4xl" v-if="revenueGenerated.analyticsData" icon="DollarSignIcon" :statistic="revenueGenerated.analyticsData.revenue" statisticTitle="Usuarios" :chartData="revenueGenerated.series" color="success" type="area" />
    </div>
    <vx-card title="Usuarios">
        <vs-table pagination max-items="7" stripe search :data="usuarios">
            <template slot="thead">
                <vs-th sort-key="email"> </vs-th>
                <vs-th sort-key="email">Cédula</vs-th>
                <vs-th sort-key="email">Nombres</vs-th>
                <vs-th sort-key="username">Teléfono</vs-th>
                <vs-th sort-key="id">Correo</vs-th>
            </template>

            <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                        <vs-avatar :text="tr.client_nombres+' '+tr.client_apellidos" />
                    </vs-td>
                    <vs-td>
                        {{ tr.client_number_id }}
                    </vs-td>
                    <vs-td>
                        {{ tr.client_nombres }} {{ tr.client_apellidos }}
                    </vs-td>
                    <vs-td :data="tr.phone">
                        {{ tr.client_phone }}
                    </vs-td>
                    <vs-td :data="tr.client_email">
                        {{ tr.client_email }}
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
    </vx-card>
</div>
</template>

<script>
import users from '@/services/usuarios'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'

export default {
    components: {
        StatisticsCardLine
    },
    data() {
        return {
            usuarios: [],
            revenueGenerated: {
                series: [{
                    name: 'Pendiente de pago',
                    data: [350, 275, 400, 300, 350, 300, 450]
                }],
                analyticsData: {
                    revenue: 0
                }
            },
        }
    },
    mounted() {
        this.getUsuarios();
    },
    methods: {
        async getUsuarios() {
            try {
                let {
                    data
                } = await users()
                this.usuarios = data
                this.revenueGenerated.analyticsData.revenue = this.usuarios.length
            } catch (error) {
                console.log(error)
            }
        }
    },
}
</script>
